import React, { createContext, useContext, useState } from 'react';

// AptMetrix 컨텍스트 생성
const AptMetrixContext = createContext();

// AptMetrix 컨텍스트 프로바이더 컴포넌트
export const AptMetrixProvider = ({ children }) => {
  // 지역 선택 정보 상태
  const [selectedRegionInfo, setSelectedRegionInfo] = useState({
    regionCode: "",
    cityCode: "",
    regionName: "",
    cityName: "",
    searchClicked: false,
    multipleSelect: false
  });

  // RegionDropdownMetrix 컴포넌트 상태 추가
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);
  const [activeRegion, setActiveRegion] = useState(null);
  const [selectedRegionNames, setSelectedRegionNames] = useState({});

  // FilterComponent UI 상태 추가 (필터 값 입력 상태)
  const [filterUIState, setFilterUIState] = useState({
    minPrice: '',
    maxPrice: '',
    minHousehold: '',
    maxHousehold: '',
    minArea: '',
    maxArea: '',
    minGap: '',
    maxGap: '',
    minYears: '',
    maxYears: '',
    selectedSubdistricts: [],
    selectedSubwayLines: [],
    maxWalkingTime: null,
    maxGangnamTime: null,
    hasSchool: true,
    isPriceFilterActive: false,
    isHouseholdFilterActive: false,
    isAreaFilterActive: false,
    isGapFilterActive: false,
    isMoveInDateFilterActive: false,
    isSubdistrictFilterActive: false,
    isSubwayFilterActive: false,
    isWalkingTimeFilterActive: false,
    isGangnamTimeFilterActive: false,
    isSchoolFilterActive: false
  });
  
  // FilterComponent의 추가 상태들
  const [filterComponentState, setFilterComponentState] = useState({
    selectedRegion: '',
    selectedCities: [],
    subdistrictOptions: [],
    subwayLines: []
  });

  // 아파트 데이터 상태
  const [aptMetrixInfo, setAptMetrixInfo] = useState(null);
  const [isFetchingAptMetrixInfo, setIsFetchingAptMetrixInfo] = useState(false);
  const [aptMetrixInfoFetchError, setAptMetrixInfoFetchError] = useState(false);
  
  // 필터 상태
  const [priceFilter, setPriceFilter] = useState({
    minPrice: null,
    maxPrice: null
  });
  
  const [householdFilter, setHouseholdFilter] = useState({
    minHousehold: null,
    maxHousehold: null
  });
  
  const [areaFilter, setAreaFilter] = useState({
    minArea: null,
    maxArea: null
  });

  const [gapFilter, setGapFilter] = useState({
    minGap: null,
    maxGap: null
  });

  const [moveInDateFilter, setMoveInDateFilter] = useState({
    minYears: null,
    maxYears: null
  });

  const [subdistrictFilter, setSubdistrictFilter] = useState([]);

  const [subwayFilter, setSubwayFilter] = useState(null);
  
  const [gangnamTimeFilter, setGangnamTimeFilter] = useState({
    maxTime: null
  });
  
  const [schoolFilter, setSchoolFilter] = useState(null);
  
  // 정렬 상태
  const [sortConfig, setSortConfig] = useState({
    key: 'current_vs_peak_price',
    direction: 'ascending'
  });

  // 모든 상태를 초기화하는 함수
  const resetAllState = () => {
    setSelectedRegionInfo({
      regionCode: "",
      cityCode: "",
      regionName: "",
      cityName: "",
      searchClicked: false,
      multipleSelect: false
    });
    setSelectedRegions([]);
    setSelectedCities([]);
    setActiveRegion(null);
    setSelectedRegionNames({});
    setFilterUIState({
      minPrice: '',
      maxPrice: '',
      minHousehold: '',
      maxHousehold: '',
      minArea: '',
      maxArea: '',
      minGap: '',
      maxGap: '',
      minYears: '',
      maxYears: '',
      selectedSubdistricts: [],
      selectedSubwayLines: [],
      maxWalkingTime: null,
      maxGangnamTime: null,
      hasSchool: true,
      isPriceFilterActive: false,
      isHouseholdFilterActive: false,
      isAreaFilterActive: false,
      isGapFilterActive: false,
      isMoveInDateFilterActive: false,
      isSubdistrictFilterActive: false,
      isSubwayFilterActive: false,
      isWalkingTimeFilterActive: false,
      isGangnamTimeFilterActive: false,
      isSchoolFilterActive: false
    });
    setFilterComponentState({
      selectedRegion: '',
      selectedCities: [],
      subdistrictOptions: [],
      subwayLines: []
    });
    setAptMetrixInfo(null);
    setIsFetchingAptMetrixInfo(false);
    setAptMetrixInfoFetchError(false);
    setPriceFilter({ minPrice: null, maxPrice: null });
    setHouseholdFilter({ minHousehold: null, maxHousehold: null });
    setAreaFilter({ minArea: null, maxArea: null });
    setGapFilter({ minGap: null, maxGap: null });
    setMoveInDateFilter({ minYears: null, maxYears: null });
    setSubdistrictFilter([]);
    setSubwayFilter(null);
    setGangnamTimeFilter({ maxTime: null });
    setSchoolFilter(null);
    setSortConfig({ key: 'current_vs_peak_price', direction: 'ascending' });
  };

  return (
    <AptMetrixContext.Provider
      value={{
        selectedRegionInfo,
        setSelectedRegionInfo,
        selectedRegions,
        setSelectedRegions,
        selectedCities,
        setSelectedCities,
        activeRegion,
        setActiveRegion,
        selectedRegionNames,
        setSelectedRegionNames,
        filterUIState,
        setFilterUIState,
        filterComponentState,
        setFilterComponentState,
        aptMetrixInfo,
        setAptMetrixInfo,
        isFetchingAptMetrixInfo,
        setIsFetchingAptMetrixInfo,
        aptMetrixInfoFetchError,
        setAptMetrixInfoFetchError,
        priceFilter,
        setPriceFilter,
        householdFilter,
        setHouseholdFilter,
        areaFilter,
        setAreaFilter,
        gapFilter,
        setGapFilter,
        moveInDateFilter,
        setMoveInDateFilter,
        subdistrictFilter,
        setSubdistrictFilter,
        subwayFilter,
        setSubwayFilter,
        gangnamTimeFilter,
        setGangnamTimeFilter,
        schoolFilter,
        setSchoolFilter,
        sortConfig,
        setSortConfig,
        resetAllState
      }}
    >
      {children}
    </AptMetrixContext.Provider>
  );
};

// 커스텀 훅으로 컨텍스트 사용 편리하게 제공
export const useAptMetrixContext = () => useContext(AptMetrixContext); 